// Multilanguage content for Hotspot Costarei — IT, EN, DE, ES, FR
// Italian is the reference source; other languages are faithful translations.

export const LANGUAGES = [
  { code: "it", label: "Italiano", flag: "IT" },
  { code: "en", label: "English", flag: "EN" },
  { code: "de", label: "Deutsch", flag: "DE" },
  { code: "es", label: "Español", flag: "ES" },
  { code: "fr", label: "Français", flag: "FR" },
];

export const translations = {
  it: {
    nav: {
      home: "Home",
      how: "Come Funziona",
      cards: "Connection Card",
      coverage: "Copertura",
      news: "Novità",
      contact: "Contatti",
      activate: "Attivati ora",
    },
    hero: {
      badge: "WiFi Outdoor ad alta velocità · Costa Rei",
      title: "Resta connesso,\novunque in vacanza",
      subtitle:
        "Hotspot Costarei porta internet wireless ad alta velocità nelle principali zone di Costa Rei, in provincia di Cagliari. Niente cavi, niente SIM: ti colleghi e navighi.",
      ctaPrimary: "Attivati ora",
      ctaSecondary: "Scopri come funziona",
      stats: [
        { value: "50 Mbit", label: "Banda aggregata" },
        { value: "Outdoor", label: "Copertura WiFi" },
        { value: "24/7", label: "Sempre online" },
      ],
    },
    welcome: {
      eyebrow: "Benvenuto",
      title: "Estate a Costa Rei? Benvenuta connessione.",
      body1:
        "Hotspot Costarei fornisce collegamento internet wireless ad alta velocità tramite una copertura WiFi outdoor presente nelle principali zone di Costa Rei.",
      body2:
        "Se sei già un utente puoi continuare a usufruire dei nostri servizi rinnovando la sottoscrizione: abbiamo esteso la rete coprendo più aree! Se invece non l'hai ancora provata, registrati e attivati subito.",
      tagline: "Enjoy the Web with Hotspot Costarei!",
      highlights: [
        "Nessuna installazione richiesta",
        "Accesso automatico alla rete",
        "Copertura sempre più capillare",
      ],
    },
    how: {
      eyebrow: "Come funziona",
      title: "Connettiti in 4 semplici passi",
      subtitle:
        "Ti basta un dispositivo WiFi (b/g/n). In pochi minuti sei online.",
      steps: [
        {
          title: "Attiva il WiFi",
          desc: "Accendi il WiFi del tuo device (smartphone, tablet o computer) nella zona di Costa Rei e connettiti alla rete HOTSPOT COSTAREI.",
        },
        {
          title: "Apri la Welcome Page",
          desc: "Comparirà automaticamente la pagina di benvenuto. Se non appare, metti il device in modalità aereo, collega il WiFi e apri http://www.fixwifi.it nel browser.",
        },
        {
          title: "Registrati",
          desc: "Seleziona il pulsante 'Registrati' e compila tutti i campi con i dati richiesti.",
        },
        {
          title: "Scegli e paga",
          desc: "Scegli come pagare: con il Voucher (codice già acquistato, in vendita presso l'edicola «Marinella») oppure tramite PayPal o Stripe dalla pagina di benvenuto. Riceverai un codice utente via SMS ed Email per accedere al servizio.",
        },
      ],
      warningTitle: "Attenzione",
      warning:
        "Verifica la presenza del segnale nella zona di interesse prima di acquistare la connection card. Le carte acquistate e utilizzate non sono rimborsabili. Con l'acquisto si accettano integralmente i Termini e Condizioni di servizio.",
    },
    cards: {
      eyebrow: "Connection Card",
      title: "Scegli il tuo accesso",
      subtitle:
        "Acquista il Voucher presso l'edicola «Marinella» (punto vendita autorizzato) oppure paga con PayPal o Stripe dalla pagina di benvenuto.",
      perDay: "navigazione",
      buy: "Attiva questa card",
      popular: "Più scelta",
      items: [
        {
          name: "1 Day",
          price: "6",
          duration: "24 ore di navigazione",
          note: "Solo con procedura online",
          features: [
            "24h dalla prima connessione",
            "Attivazione online immediata",
            "Pagamento PayPal / carta",
          ],
        },
        {
          name: "1 Week",
          price: "15",
          duration: "7 giorni di navigazione",
          note: "WIFI card o procedura online",
          features: [
            "7 giorni dalla prima connessione",
            "WIFI card o acquisto online",
            "La scelta dei soggiorni lunghi",
          ],
        },
      ],
      finePrint:
        "I giorni di navigazione decorrono dalla prima connessione (es. 1 giorno: ti connetti oggi alle 16, scade domani alle 16).",
    },
    coverage: {
      eyebrow: "Copertura",
      title: "Dove arriva il nostro segnale",
      body:
        "Il servizio è indirizzato al WiFi Outdoor. Costa Rei non è pianeggiante ma collinare: se dal tuo balcone vedi uno dei punti di diffusione, avrai sicuramente copertura.",
      body2:
        "Vuoi il servizio presso la tua proprietà? Contattaci e porteremo Hotspot Costarei anche a casa tua, così i tuoi ospiti potranno usufruirne.",
      mapButton: "Apri la mappa copertura",
      points: [
        { label: "Punti attivi", color: "active" },
        { label: "In attivazione", color: "soon" },
      ],
    },
    news: {
      eyebrow: "Novità",
      title: "Ultime dalla rete",
      items: [
        {
          tag: "Rete",
          title: "Banda aggregata di 50 Megabit",
          desc: "Abbiamo potenziato la capacità complessiva della rete per una navigazione più fluida.",
        },
        {
          tag: "Accesso",
          title: "Nuovo accesso automatico",
          desc: "Connessione semplificata: la welcome page compare automaticamente al collegamento.",
        },
        {
          tag: "Copertura",
          title: "Copertura più capillare",
          desc: "Abbiamo esteso la rete coprendo più aree di Costa Rei.",
        },
      ],
    },
    contact: {
      eyebrow: "Contatti",
      title: "Hai una proprietà? Portiamo il WiFi da te",
      subtitle:
        "Compila il form se desideri ottenere il servizio o hai bisogno di informazioni. Ti risponderemo al più presto.",
      form: {
        name: "Nome",
        email: "Email",
        phone: "Cellulare",
        subject: "Oggetto",
        subjectOptions: [
          "Richiesta informazioni",
          "Richiesta copertura",
          "Altro",
        ],
        message: "Messaggio",
        send: "Invia richiesta",
        sending: "Invio in corso...",
        success: "Richiesta inviata! Ti ricontatteremo a breve.",
        error: "Si è verificato un errore. Riprova.",
      },
      mgmtTitle: "Management",
      mgmt: ["Folgore di Antonio Dell'Aglio", "via Malocco Sotto 37", "25017 Lonato BS", "ITALY"],
      hqTitle: "HeadQuarters",
      hq: ["Piscina Rei - Costa Rei", "09040 Cagliari"],
      phone: "+39 070 7732188",
      email: "info@hotspotcostarei.it",
      hoursTitle: "Assistenza",
      hours: ["Lun – Ven: 10:00 – 11:30", "17:00 – 18:30"],
    },
    footer: {
      tagline: "WiFi outdoor ad alta velocità per Costa Rei.",
      cols: {
        service: "Servizio",
        company: "Azienda",
        contact: "Contatti",
      },
      links: {
        how: "Come Funziona",
        cards: "Connection Card",
        coverage: "Copertura",
        news: "Novità",
        terms: "Termini e Condizioni",
      },
      rights: "Tutti i diritti riservati.",
    },
    cookie: {
      text: "Questo sito utilizza cookie. Continuando a navigare accetti l'utilizzo dei cookie.",
      accept: "OK",
    },
  },

  en: {
    nav: { home: "Home", how: "How it Works", cards: "Connection Card", coverage: "Coverage", news: "News", contact: "Contact", activate: "Activate now" },
    hero: {
      badge: "High-speed outdoor WiFi · Costa Rei",
      title: "Stay connected,\nanywhere on holiday",
      subtitle:
        "Hotspot Costarei brings high-speed wireless internet to the main areas of Costa Rei, near Cagliari. No cables, no SIM: just connect and browse.",
      ctaPrimary: "Activate now",
      ctaSecondary: "See how it works",
      stats: [
        { value: "50 Mbit", label: "Aggregate bandwidth" },
        { value: "Outdoor", label: "WiFi coverage" },
        { value: "24/7", label: "Always online" },
      ],
    },
    welcome: {
      eyebrow: "Welcome",
      title: "Summer in Costa Rei? Welcome connection.",
      body1:
        "Hotspot Costarei provides high-speed wireless internet through outdoor WiFi coverage across the main areas of Costa Rei.",
      body2:
        "Already a user? Keep enjoying our services by renewing your subscription — we have expanded the network to cover more areas! New here? Register and get activated right away.",
      tagline: "Enjoy the Web with Hotspot Costarei!",
      highlights: ["No installation required", "Automatic network access", "Ever wider coverage"],
    },
    how: {
      eyebrow: "How it works",
      title: "Get online in 4 simple steps",
      subtitle: "All you need is a WiFi device (b/g/n). Online in minutes.",
      steps: [
        { title: "Turn on WiFi", desc: "Switch on your device's WiFi (phone, tablet or computer) in the Costa Rei area and connect to the HOTSPOT COSTAREI network." },
        { title: "Open the Welcome Page", desc: "The welcome page appears automatically. If not, set the device to airplane mode, connect to WiFi and open http://www.fixwifi.it in your browser." },
        { title: "Register", desc: "Tap 'Register' and fill in all the required fields." },
        { title: "Choose & pay", desc: "Pay with a Voucher (pre-purchased code, on sale at the «Marinella» newsstand) or via PayPal or Stripe from the welcome page. You'll receive a user code via SMS and Email to access the service." },
      ],
      warningTitle: "Please note",
      warning:
        "Check the signal in your area before buying a connection card. Used cards are non-refundable. By purchasing you fully accept the Terms & Conditions of service.",
    },
    cards: {
      eyebrow: "Connection Card",
      title: "Choose your access",
      subtitle: "Buy the Voucher at the «Marinella» newsstand (authorized reseller) or pay with PayPal or Stripe from the welcome page.",
      perDay: "browsing",
      buy: "Activate this card",
      popular: "Most popular",
      items: [
        { name: "1 Day", price: "6", duration: "24 hours of browsing", note: "Online purchase only", features: ["24h from first connection", "Instant online activation", "PayPal / card payment"] },
        { name: "1 Week", price: "15", duration: "7 days of browsing", note: "WIFI card or online", features: ["7 days from first connection", "WIFI card or online purchase", "Best for longer stays"] },
      ],
      finePrint: "Browsing days start from the first connection (e.g. 1 day: connect today at 4pm, expires tomorrow at 4pm).",
    },
    coverage: {
      eyebrow: "Coverage",
      title: "Where our signal reaches",
      body: "The service is designed for outdoor WiFi. Costa Rei is hilly, not flat: if you can see one of the broadcast points from your balcony, you'll have coverage.",
      body2: "Want the service at your property? Contact us and we'll bring Hotspot Costarei to your home, so your guests can enjoy it too.",
      mapButton: "Open coverage map",
      points: [{ label: "Active points", color: "active" }, { label: "Coming soon", color: "soon" }],
    },
    news: {
      eyebrow: "News",
      title: "Latest from the network",
      items: [
        { tag: "Network", title: "50 Megabit aggregate bandwidth", desc: "We boosted the overall network capacity for smoother browsing." },
        { tag: "Access", title: "New automatic access", desc: "Simplified connection: the welcome page appears automatically on connect." },
        { tag: "Coverage", title: "Wider coverage", desc: "We expanded the network to cover more areas of Costa Rei." },
      ],
    },
    contact: {
      eyebrow: "Contact",
      title: "Own a property? We'll bring WiFi to you",
      subtitle: "Fill in the form if you'd like the service or need information. We'll get back to you soon.",
      form: {
        name: "Name", email: "Email", phone: "Phone", subject: "Subject",
        subjectOptions: ["Information request", "Coverage request", "Other"],
        message: "Message", send: "Send request", sending: "Sending...",
        success: "Request sent! We'll contact you shortly.", error: "An error occurred. Please try again.",
      },
      mgmtTitle: "Management",
      mgmt: ["Folgore di Antonio Dell'Aglio", "via Malocco Sotto 37", "25017 Lonato BS", "ITALY"],
      hqTitle: "HeadQuarters",
      hq: ["Piscina Rei - Costa Rei", "09040 Cagliari"],
      phone: "+39 070 7732188",
      email: "info@hotspotcostarei.it",
      hoursTitle: "Support",
      hours: ["Mon – Fri: 10:00 – 11:30", "17:00 – 18:30"],
    },
    footer: {
      tagline: "High-speed outdoor WiFi for Costa Rei.",
      cols: { service: "Service", company: "Company", contact: "Contact" },
      links: { how: "How it Works", cards: "Connection Card", coverage: "Coverage", news: "News", terms: "Terms & Conditions" },
      rights: "All rights reserved.",
    },
    cookie: { text: "This site uses cookies. By continuing to browse you accept the use of cookies.", accept: "OK" },
  },

  de: {
    nav: { home: "Home", how: "So funktioniert's", cards: "Connection Card", coverage: "Abdeckung", news: "Neuigkeiten", contact: "Kontakt", activate: "Jetzt aktivieren" },
    hero: {
      badge: "Schnelles Outdoor-WLAN · Costa Rei",
      title: "Immer verbunden,\nüberall im Urlaub",
      subtitle:
        "Hotspot Costarei bringt schnelles drahtloses Internet in die wichtigsten Gebiete von Costa Rei bei Cagliari. Keine Kabel, keine SIM: einfach verbinden und surfen.",
      ctaPrimary: "Jetzt aktivieren",
      ctaSecondary: "So funktioniert's",
      stats: [
        { value: "50 Mbit", label: "Gesamtbandbreite" },
        { value: "Outdoor", label: "WLAN-Abdeckung" },
        { value: "24/7", label: "Immer online" },
      ],
    },
    welcome: {
      eyebrow: "Willkommen",
      title: "Sommer in Costa Rei? Willkommen Verbindung.",
      body1:
        "Hotspot Costarei bietet schnelles drahtloses Internet über Outdoor-WLAN in den wichtigsten Gebieten von Costa Rei.",
      body2:
        "Schon Kunde? Nutzen Sie unsere Dienste weiter, indem Sie Ihr Abo verlängern — wir haben das Netz erweitert! Noch nicht dabei? Registrieren und sofort aktivieren.",
      tagline: "Enjoy the Web with Hotspot Costarei!",
      highlights: ["Keine Installation nötig", "Automatischer Netzzugang", "Immer größere Abdeckung"],
    },
    how: {
      eyebrow: "So funktioniert's",
      title: "In 4 einfachen Schritten online",
      subtitle: "Sie brauchen nur ein WLAN-Gerät (b/g/n). In Minuten online.",
      steps: [
        { title: "WLAN einschalten", desc: "Schalten Sie das WLAN Ihres Geräts (Handy, Tablet oder Computer) im Gebiet Costa Rei ein und verbinden Sie sich mit dem Netz HOTSPOT COSTAREI." },
        { title: "Welcome-Page öffnen", desc: "Die Willkommensseite erscheint automatisch. Falls nicht, Gerät in den Flugmodus, mit WLAN verbinden und http://www.fixwifi.it öffnen." },
        { title: "Registrieren", desc: "Tippen Sie auf 'Registrieren' und füllen Sie alle Felder aus." },
        { title: "Wählen & zahlen", desc: "Zahlen Sie per Voucher (vorab gekaufter Code, erhältlich am Kiosk «Marinella») oder per PayPal oder Stripe über die Welcome-Page. Sie erhalten einen Benutzercode per SMS und E-Mail." },
      ],
      warningTitle: "Achtung",
      warning:
        "Prüfen Sie das Signal in Ihrem Gebiet vor dem Kauf einer Connection Card. Benutzte Karten sind nicht erstattungsfähig. Mit dem Kauf akzeptieren Sie die AGB vollständig.",
    },
    cards: {
      eyebrow: "Connection Card",
      title: "Wählen Sie Ihren Zugang",
      subtitle: "Voucher am Kiosk «Marinella» (autorisierter Händler) kaufen oder per PayPal oder Stripe über die Welcome-Page zahlen.",
      perDay: "surfen",
      buy: "Diese Karte aktivieren",
      popular: "Beliebt",
      items: [
        { name: "1 Day", price: "6", duration: "24 Stunden surfen", note: "Nur online", features: ["24h ab erster Verbindung", "Sofortige Online-Aktivierung", "PayPal / Kartenzahlung"] },
        { name: "1 Week", price: "15", duration: "7 Tage surfen", note: "WIFI-Karte oder online", features: ["7 Tage ab erster Verbindung", "WIFI-Karte oder online", "Ideal für längere Aufenthalte"] },
      ],
      finePrint: "Die Surftage beginnen mit der ersten Verbindung (z. B. 1 Tag: heute 16 Uhr verbinden, morgen 16 Uhr Ablauf).",
    },
    coverage: {
      eyebrow: "Abdeckung",
      title: "Wo unser Signal ankommt",
      body: "Der Dienst ist für Outdoor-WLAN ausgelegt. Costa Rei ist hügelig: Wenn Sie von Ihrem Balkon einen Sendepunkt sehen, haben Sie Empfang.",
      body2: "Möchten Sie den Dienst an Ihrer Immobilie? Kontaktieren Sie uns — wir bringen Hotspot Costarei zu Ihnen, auch für Ihre Gäste.",
      mapButton: "Abdeckungskarte öffnen",
      points: [{ label: "Aktive Punkte", color: "active" }, { label: "In Aktivierung", color: "soon" }],
    },
    news: {
      eyebrow: "Neuigkeiten",
      title: "Neues aus dem Netz",
      items: [
        { tag: "Netz", title: "50 Megabit Gesamtbandbreite", desc: "Wir haben die Netzkapazität für flüssigeres Surfen erhöht." },
        { tag: "Zugang", title: "Neuer automatischer Zugang", desc: "Vereinfachte Verbindung: Die Welcome-Page erscheint automatisch." },
        { tag: "Abdeckung", title: "Größere Abdeckung", desc: "Wir haben das Netz in Costa Rei erweitert." },
      ],
    },
    contact: {
      eyebrow: "Kontakt",
      title: "Haben Sie eine Immobilie? Wir bringen WLAN zu Ihnen",
      subtitle: "Füllen Sie das Formular aus, wenn Sie den Dienst wünschen oder Infos brauchen. Wir melden uns bald.",
      form: {
        name: "Name", email: "E-Mail", phone: "Telefon", subject: "Betreff",
        subjectOptions: ["Informationsanfrage", "Abdeckungsanfrage", "Sonstiges"],
        message: "Nachricht", send: "Anfrage senden", sending: "Senden...",
        success: "Anfrage gesendet! Wir melden uns in Kürze.", error: "Ein Fehler ist aufgetreten. Bitte erneut versuchen.",
      },
      mgmtTitle: "Management",
      mgmt: ["Folgore di Antonio Dell'Aglio", "via Malocco Sotto 37", "25017 Lonato BS", "ITALIEN"],
      hqTitle: "HeadQuarters",
      hq: ["Piscina Rei - Costa Rei", "09040 Cagliari"],
      phone: "+39 070 7732188",
      email: "info@hotspotcostarei.it",
      hoursTitle: "Support",
      hours: ["Mo – Fr: 10:00 – 11:30", "17:00 – 18:30"],
    },
    footer: {
      tagline: "Schnelles Outdoor-WLAN für Costa Rei.",
      cols: { service: "Service", company: "Unternehmen", contact: "Kontakt" },
      links: { how: "So funktioniert's", cards: "Connection Card", coverage: "Abdeckung", news: "Neuigkeiten", terms: "AGB" },
      rights: "Alle Rechte vorbehalten.",
    },
    cookie: { text: "Diese Seite verwendet Cookies. Durch weitere Nutzung akzeptieren Sie Cookies.", accept: "OK" },
  },

  es: {
    nav: { home: "Inicio", how: "Cómo funciona", cards: "Connection Card", coverage: "Cobertura", news: "Novedades", contact: "Contacto", activate: "Activar ahora" },
    hero: {
      badge: "WiFi exterior de alta velocidad · Costa Rei",
      title: "Siempre conectado,\nen cualquier lugar",
      subtitle:
        "Hotspot Costarei lleva internet inalámbrico de alta velocidad a las principales zonas de Costa Rei, cerca de Cagliari. Sin cables, sin SIM: conéctate y navega.",
      ctaPrimary: "Activar ahora",
      ctaSecondary: "Ver cómo funciona",
      stats: [
        { value: "50 Mbit", label: "Ancho de banda total" },
        { value: "Exterior", label: "Cobertura WiFi" },
        { value: "24/7", label: "Siempre online" },
      ],
    },
    welcome: {
      eyebrow: "Bienvenido",
      title: "¿Verano en Costa Rei? Bienvenida conexión.",
      body1:
        "Hotspot Costarei ofrece internet inalámbrico de alta velocidad mediante cobertura WiFi exterior en las principales zonas de Costa Rei.",
      body2:
        "¿Ya eres usuario? Sigue disfrutando renovando tu suscripción — ¡hemos ampliado la red! ¿Aún no la has probado? Regístrate y actívate ahora.",
      tagline: "Enjoy the Web with Hotspot Costarei!",
      highlights: ["Sin instalación", "Acceso automático a la red", "Cobertura cada vez más amplia"],
    },
    how: {
      eyebrow: "Cómo funciona",
      title: "Conéctate en 4 sencillos pasos",
      subtitle: "Solo necesitas un dispositivo WiFi (b/g/n). Online en minutos.",
      steps: [
        { title: "Activa el WiFi", desc: "Enciende el WiFi de tu dispositivo (móvil, tablet u ordenador) en la zona de Costa Rei y conéctate a la red HOTSPOT COSTAREI." },
        { title: "Abre la Welcome Page", desc: "La página de bienvenida aparece automáticamente. Si no, pon el dispositivo en modo avión, conecta el WiFi y abre http://www.fixwifi.it en el navegador." },
        { title: "Regístrate", desc: "Pulsa 'Registrarse' y rellena todos los campos requeridos." },
        { title: "Elige y paga", desc: "Paga con Voucher (código ya comprado, a la venta en el quiosco «Marinella») o mediante PayPal o Stripe desde la welcome page. Recibirás un código de usuario por SMS y Email." },
      ],
      warningTitle: "Atención",
      warning:
        "Verifica la señal en tu zona antes de comprar la connection card. Las tarjetas usadas no son reembolsables. Al comprar aceptas íntegramente los Términos y Condiciones.",
    },
    cards: {
      eyebrow: "Connection Card",
      title: "Elige tu acceso",
      subtitle: "Compra el Voucher en el quiosco «Marinella» (punto autorizado) o paga con PayPal o Stripe desde la welcome page.",
      perDay: "navegación",
      buy: "Activar esta tarjeta",
      popular: "Más elegido",
      items: [
        { name: "1 Day", price: "6", duration: "24 horas de navegación", note: "Solo online", features: ["24h desde la primera conexión", "Activación online inmediata", "Pago PayPal / tarjeta"] },
        { name: "1 Week", price: "15", duration: "7 días de navegación", note: "Tarjeta WIFI u online", features: ["7 días desde la primera conexión", "Tarjeta WIFI u online", "Ideal para estancias largas"] },
      ],
      finePrint: "Los días cuentan desde la primera conexión (ej. 1 día: conectas hoy a las 16h, caduca mañana a las 16h).",
    },
    coverage: {
      eyebrow: "Cobertura",
      title: "Hasta dónde llega nuestra señal",
      body: "El servicio está pensado para WiFi exterior. Costa Rei es montañosa: si ves un punto de emisión desde tu balcón, tendrás cobertura.",
      body2: "¿Quieres el servicio en tu propiedad? Contáctanos y llevaremos Hotspot Costarei a tu casa, para que tus huéspedes también disfruten.",
      mapButton: "Abrir mapa de cobertura",
      points: [{ label: "Puntos activos", color: "active" }, { label: "Próximamente", color: "soon" }],
    },
    news: {
      eyebrow: "Novedades",
      title: "Lo último de la red",
      items: [
        { tag: "Red", title: "50 Megabit de ancho de banda", desc: "Hemos aumentado la capacidad de la red para navegar con más fluidez." },
        { tag: "Acceso", title: "Nuevo acceso automático", desc: "Conexión simplificada: la welcome page aparece automáticamente." },
        { tag: "Cobertura", title: "Cobertura más amplia", desc: "Hemos ampliado la red en más zonas de Costa Rei." },
      ],
    },
    contact: {
      eyebrow: "Contacto",
      title: "¿Tienes una propiedad? Llevamos el WiFi a ti",
      subtitle: "Rellena el formulario si deseas el servicio o necesitas información. Te responderemos pronto.",
      form: {
        name: "Nombre", email: "Email", phone: "Teléfono", subject: "Asunto",
        subjectOptions: ["Solicitud de información", "Solicitud de cobertura", "Otro"],
        message: "Mensaje", send: "Enviar solicitud", sending: "Enviando...",
        success: "¡Solicitud enviada! Te contactaremos pronto.", error: "Ha ocurrido un error. Inténtalo de nuevo.",
      },
      mgmtTitle: "Management",
      mgmt: ["Folgore di Antonio Dell'Aglio", "via Malocco Sotto 37", "25017 Lonato BS", "ITALIA"],
      hqTitle: "HeadQuarters",
      hq: ["Piscina Rei - Costa Rei", "09040 Cagliari"],
      phone: "+39 070 7732188",
      email: "info@hotspotcostarei.it",
      hoursTitle: "Asistencia",
      hours: ["Lun – Vie: 10:00 – 11:30", "17:00 – 18:30"],
    },
    footer: {
      tagline: "WiFi exterior de alta velocidad para Costa Rei.",
      cols: { service: "Servicio", company: "Empresa", contact: "Contacto" },
      links: { how: "Cómo funciona", cards: "Connection Card", coverage: "Cobertura", news: "Novedades", terms: "Términos y Condiciones" },
      rights: "Todos los derechos reservados.",
    },
    cookie: { text: "Este sitio usa cookies. Al continuar navegando aceptas el uso de cookies.", accept: "OK" },
  },

  fr: {
    nav: { home: "Accueil", how: "Comment ça marche", cards: "Connection Card", coverage: "Couverture", news: "Actualités", contact: "Contact", activate: "Activer maintenant" },
    hero: {
      badge: "WiFi extérieur haut débit · Costa Rei",
      title: "Restez connecté,\npartout en vacances",
      subtitle:
        "Hotspot Costarei apporte internet sans fil haut débit dans les principales zones de Costa Rei, près de Cagliari. Sans câble, sans SIM : connectez-vous et naviguez.",
      ctaPrimary: "Activer maintenant",
      ctaSecondary: "Voir comment ça marche",
      stats: [
        { value: "50 Mbit", label: "Bande passante totale" },
        { value: "Extérieur", label: "Couverture WiFi" },
        { value: "24/7", label: "Toujours en ligne" },
      ],
    },
    welcome: {
      eyebrow: "Bienvenue",
      title: "Été à Costa Rei ? Bienvenue la connexion.",
      body1:
        "Hotspot Costarei fournit internet sans fil haut débit via une couverture WiFi extérieure dans les principales zones de Costa Rei.",
      body2:
        "Déjà client ? Continuez à profiter de nos services en renouvelant votre abonnement — nous avons étendu le réseau ! Pas encore essayé ? Inscrivez-vous et activez tout de suite.",
      tagline: "Enjoy the Web with Hotspot Costarei!",
      highlights: ["Aucune installation", "Accès réseau automatique", "Couverture toujours plus large"],
    },
    how: {
      eyebrow: "Comment ça marche",
      title: "En ligne en 4 étapes simples",
      subtitle: "Il vous suffit d'un appareil WiFi (b/g/n). En ligne en quelques minutes.",
      steps: [
        { title: "Activez le WiFi", desc: "Activez le WiFi de votre appareil (mobile, tablette ou ordinateur) dans la zone de Costa Rei et connectez-vous au réseau HOTSPOT COSTAREI." },
        { title: "Ouvrez la Welcome Page", desc: "La page d'accueil apparaît automatiquement. Sinon, mettez l'appareil en mode avion, connectez le WiFi et ouvrez http://www.fixwifi.it dans le navigateur." },
        { title: "Inscrivez-vous", desc: "Appuyez sur 'S'inscrire' et remplissez tous les champs requis." },
        { title: "Choisissez et payez", desc: "Payez par Voucher (code déjà acheté, en vente au kiosque «Marinella») ou via PayPal ou Stripe depuis la welcome page. Vous recevrez un code utilisateur par SMS et Email." },
      ],
      warningTitle: "Attention",
      warning:
        "Vérifiez le signal dans votre zone avant d'acheter une connection card. Les cartes utilisées ne sont pas remboursables. En achetant, vous acceptez intégralement les Conditions de service.",
    },
    cards: {
      eyebrow: "Connection Card",
      title: "Choisissez votre accès",
      subtitle: "Achetez le Voucher au kiosque «Marinella» (revendeur agréé) ou payez avec PayPal ou Stripe depuis la welcome page.",
      perDay: "navigation",
      buy: "Activer cette carte",
      popular: "Le plus choisi",
      items: [
        { name: "1 Day", price: "6", duration: "24 heures de navigation", note: "En ligne uniquement", features: ["24h dès la première connexion", "Activation en ligne immédiate", "Paiement PayPal / carte"] },
        { name: "1 Week", price: "15", duration: "7 jours de navigation", note: "Carte WIFI ou en ligne", features: ["7 jours dès la première connexion", "Carte WIFI ou en ligne", "Idéal pour les longs séjours"] },
      ],
      finePrint: "Les jours démarrent à la première connexion (ex. 1 jour : connexion aujourd'hui à 16h, expiration demain à 16h).",
    },
    coverage: {
      eyebrow: "Couverture",
      title: "Jusqu'où arrive notre signal",
      body: "Le service est conçu pour le WiFi extérieur. Costa Rei est vallonnée : si vous voyez un point d'émission depuis votre balcon, vous aurez de la couverture.",
      body2: "Vous voulez le service chez vous ? Contactez-nous et nous apporterons Hotspot Costarei à votre domicile, pour vos hôtes aussi.",
      mapButton: "Ouvrir la carte de couverture",
      points: [{ label: "Points actifs", color: "active" }, { label: "Bientôt disponible", color: "soon" }],
    },
    news: {
      eyebrow: "Actualités",
      title: "Les dernières du réseau",
      items: [
        { tag: "Réseau", title: "50 Mégabit de bande passante", desc: "Nous avons augmenté la capacité du réseau pour une navigation plus fluide." },
        { tag: "Accès", title: "Nouvel accès automatique", desc: "Connexion simplifiée : la welcome page apparaît automatiquement." },
        { tag: "Couverture", title: "Couverture élargie", desc: "Nous avons étendu le réseau à davantage de zones de Costa Rei." },
      ],
    },
    contact: {
      eyebrow: "Contact",
      title: "Vous avez une propriété ? Nous apportons le WiFi",
      subtitle: "Remplissez le formulaire si vous souhaitez le service ou des informations. Nous vous répondrons vite.",
      form: {
        name: "Nom", email: "Email", phone: "Téléphone", subject: "Objet",
        subjectOptions: ["Demande d'informations", "Demande de couverture", "Autre"],
        message: "Message", send: "Envoyer la demande", sending: "Envoi...",
        success: "Demande envoyée ! Nous vous contacterons bientôt.", error: "Une erreur s'est produite. Réessayez.",
      },
      mgmtTitle: "Management",
      mgmt: ["Folgore di Antonio Dell'Aglio", "via Malocco Sotto 37", "25017 Lonato BS", "ITALIE"],
      hqTitle: "HeadQuarters",
      hq: ["Piscina Rei - Costa Rei", "09040 Cagliari"],
      phone: "+39 070 7732188",
      email: "info@hotspotcostarei.it",
      hoursTitle: "Assistance",
      hours: ["Lun – Ven : 10:00 – 11:30", "17:00 – 18:30"],
    },
    footer: {
      tagline: "WiFi extérieur haut débit pour Costa Rei.",
      cols: { service: "Service", company: "Société", contact: "Contact" },
      links: { how: "Comment ça marche", cards: "Connection Card", coverage: "Couverture", news: "Actualités", terms: "Conditions générales" },
      rights: "Tous droits réservés.",
    },
    cookie: { text: "Ce site utilise des cookies. En continuant, vous acceptez l'utilisation des cookies.", accept: "OK" },
  },
};
